import { IPhoneCall } from '@admin/types/phone_call';

export enum InteractableType {
  PHONE_CALL = 'PhoneCall',
}

export interface ICustomerInteraction {
  id: string;
  interactableType: InteractableType;
  interactable: IPhoneCall;
}
